<template>
  <div :id="componentId" class="sp-four-module-2">
    <div class="sp42-item-list">
      <div
        v-for="(item, index) in displayList"
        :key="index"
        class="sp42-item-card"
      >
        <!-- 背景图：绝对定位铺满 -->
        <img
          v-if="item.backgroundImage"
          class="sp42-bg-image"
          :src="item.backgroundImage"
          alt=""
        />

        <!-- logo 图片 -->
        <img
          v-if="item.imageUrl"
          class="sp42-logo-image"
          :src="item.imageUrl"
          alt=""
        />

        <!-- 底部文字 -->
        <div
          v-if="item.name"
          class="sp42-item-text"
          :style="{ color: item.textColor || '#FFFFFF' }"
        >
          {{ item.name }}
        </div>
      </div>

      <!-- 空状态提示 -->
      <div v-if="!displayList.length" class="sp42-empty-tip">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpFourModule2',
  props: {
    componentId: {
      type: String,
      default: 'sp_four_module_2'
    },
    pageModules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 默认数据
      list: [
        { imageUrl: '', name: '名称示例 1', textColor: '#FFFFFF', backgroundImage: '' },
        { imageUrl: '', name: '名称示例 2', textColor: '#FFFFFF', backgroundImage: '' },
        { imageUrl: '', name: '名称示例 3', textColor: '#FFFFFF', backgroundImage: '' },
        { imageUrl: '', name: '名称示例 4', textColor: '#FFFFFF', backgroundImage: '' },
        { imageUrl: '', name: '名称示例 5', textColor: '#FFFFFF', backgroundImage: '' },
        { imageUrl: '', name: '名称示例 6', textColor: '#FFFFFF', backgroundImage: '' }
      ]
    }
  },
  computed: {
    displayList() {
      return this.list || []
    }
  }
}
</script>

<style scoped>
.sp-four-module-2 {
  position: relative;
  width: 1400px;
  min-width: 1400px;
  max-width: 1400px;
  left: 50%;
  transform: translateX(-50%);
  padding: 30px 0;
}

.sp42-item-list {
  display: flex;
  width: 1400px;
  min-width: 1400px;
  max-width: 1400px;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
}

/* 卡片容器 */
.sp42-item-card {
  position: relative;
  width: 213px !important;
  height: 208px !important;
  border-radius: 0 !important;
  overflow: hidden !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

/* 背景图：100% 填充 */
.sp42-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: 1;
  pointer-events: none;
}

/* Logo 图片 - 直接定位在卡片中央 */
.sp42-logo-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: calc(100% - 20px);
  object-fit: contain;
  z-index: 10;
}

/* 底部文字 */
.sp42-item-text {
  position: absolute;
  bottom: 11px;
  left: 50%;
  transform: translateX(-50%);
  width: 179px;
  height: 24px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  z-index: 2;
}

/* 空状态 */
.sp42-empty-tip {
  width: 100%;
  padding: 40px 0;
  text-align: center;
  color: #909399;
  font-size: 14px;
}
</style>
